import { useRef } from 'react';

import { QuoteForm } from './components/QuoteForm';
import { runtimeConfig } from './config/runtime';
import { useIframeBridge } from './hooks/useIframeBridge';

export const App = () => {
  const containerRef = useRef<HTMLElement>(null);
  const { notifySubmitted } = useIframeBridge(
    containerRef,
    runtimeConfig.parentOrigin,
  );

  return (
    <main className="embed-shell" ref={containerRef}>
      <QuoteForm onSubmitted={notifySubmitted} />
    </main>
  );
};
